import type { HeroData } from '../helpers/types';

export function getTrackedHero(
    activeHeroes: HeroData[],
    selectedRacer: string,
    betOnRacer: string,
): HeroData | undefined {
    const trackedName = selectedRacer || betOnRacer;

    if (trackedName) {
        return activeHeroes.find((h) => h.name === trackedName);
    }

    return activeHeroes.reduce<HeroData | undefined>(
        (leader, hero) =>
            !leader || hero.position < leader.position ? hero : leader,
        undefined,
    );
}
